import { roles } from 'features/hoc';

export const logsRoleRules = {
  menu: { min: roles.admin.value },
  discover: { min: roles.admin.value },
  moderators: { min: roles.admin.value },
  payment: { min: roles.admin.value },
};
